import { Loader } from '@mantine/core';

export function PageLoader({ label = 'Loading' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-label={label}
      className="flex min-h-[60vh] grow items-center justify-center"
    >
      <Loader color="brand" size="lg" />
    </div>
  );
}
